import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PaymentAccounts from "./../../Payment/PaymentAccounts";

export default function DuaPayment() {
  return (
    <div>
      <section className="mb-10" id="send-money">
        <div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mt-5 mb-10">
            <div className="lg:col-span-2">
              <p className=" mt-3">
                নিচের যে কোন নাম্বারে টাকা পাঠান (
                <span className="text-red-500 font-bold"> Send Money </span>)
              </p>
              <p className="">
                <FontAwesomeIcon
                  className="text-slate-500 me-1"
                  icon={"fa-solid fa-copy"}
                />{" "}
                একাউন্ট নাম্বার কপি করতে নাম্বারের উপর ক্লিক করুন।
              </p>
              <p className="">
                <strong className="text-red-600">
                  দোকান থেকে টাকা না পাঠিয়ে{" "}
                </strong>{" "}
                নিজের/বাড়ির কারো নাম্বার থেকে পাঠান, তাহলে টাকাটা গেল কিনা, ঠিক
                নাম্বারে গেল কিনা নিশ্চিত হতে পারবেন।{" "}
              </p>
              <p className="mt-1 mb-5">
                <FontAwesomeIcon
                  className="text-blue-500 me-1"
                  icon={"image"}
                />{" "}
                সম্ভব হলে টাকা পাঠানোর পর{" "}
                <strong className="text-blue-600">
                  স্ক্রিনশট/মানি রিসিটের ছবি
                </strong>{" "}
                তুলুন।{" "}
              </p>
            </div>
            <div>
              <p className="font-bold">টাকার পরিমাণ:</p>
              <div>
                <p>৮০০ টাকা / ৬৭৫ রুপি</p>
              </div>
            </div>
          </div>

          <PaymentAccounts />
        </div>
      </section>
    </div>
  );
}
